import {SmartComponent} from "smart-component-js";

class ReceiptComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.receiptPage = this.element.querySelector('.load-receipt-invoice.receipt');
        this.init();
    }


    addStepperProgress() {
        if (this.receiptPage) {
            const stepperContainer = document.createElement("div");
            stepperContainer.classList.add("stepper-container");

            stepperContainer.innerHTML = `
       <div class="stepper-wrapper">
                <div class="step-line">
                    <div class="step-progress"></div>
                </div>
            </div>
           `;
            this.receiptPage.prepend(stepperContainer);
            this.updateStepper();
        }
    }


    updateStepper(step = 1) {
        this.currentStep = step;
        const stepProgress = this.receiptPage.querySelector(".step-progress");
        if (stepProgress) {
            stepProgress.style.width = step === 1 ? "50%" : "100%";
        }
    }

    toggleLabelVisibility() {
        document.addEventListener('yxp-loyalty-receipt-file-uploaded', () => {
            const firstStep = this.element.querySelector('.first-step');
            const secondStep = this.element.querySelector('.second-step');
            if (!firstStep || !secondStep) return;
            firstStep.classList.add('hidden');
            secondStep.classList.remove('hidden');
            this.updateStepper(2);
            this.element.querySelector('.yxp-rw-step.intro').classList.add('hidden');
        });
    }

    checkMonthLimit() {
        document.addEventListener('yxp-loyalty-receipt-config-error', (e) => {

            this.limitExcedeed = e.detail.errorCode;

            if (this.limitExcedeed) {
                location.href = '/reserved/limite-caricamento';
            }
        })
        this.element.classList.remove('loading');
    }


    addThankYouPageListener() {
        document.addEventListener("yxp-loyalty-receipt-ok", (e) => {

            if (e.detail && e.detail.body) {

                const costProduct = Math.round(e.detail.body.productList.reduce((sum, product) => {
                    return sum + parseFloat(product.amount);
                }, 0) * 100
                ) / 100

                const earnedPoints = e.detail.body.missionOutput?.TOTAL_TO_BE_ACCOUNTED_POINTS;
                const childMissionResults = e.detail.body.missionOutput?.CHILD_MISSION_RESULTS || [];

                this.element.querySelector('.yxp-rw2-success-wrapper').classList.add('hidden');
                this.createThankyouPage(costProduct, earnedPoints, childMissionResults);

            }
        });
    }


    createThankyouPage(costProduct, earnedPoints, childMissionResults) {

        const bonusHtml = childMissionResults
            .filter(m => m.missionCode === "first-receipt" && m.TO_BE_ACCOUNTED_POINTS)
            .map(m => `
                <div class="mb-30">
                    <div><b>${GENERIC_TRANSLATIONS.firstReceipt}</b></div>
                    <div class="icon">
                        <div class="chips-points">
                            <span class="chips-points__content">${m.TO_BE_ACCOUNTED_POINTS} Punti Cuore</span>
                        </div>
                    </div>
                </div>
                `)
            .join('');

        let html = `
            <div class="load-receipt-tnk">
                <img src="/fe-web/img/mydonnad/load-receipt-tnk.png" />
               
               <div class="yxpType_TITLE playfair">
                        <h1 >
                            Hai caricato correttamente ${this.receiptPage ?
            `il tuo scontrino!` : `la tua ricevuta!`}
                        </h1> 
                </div>     
                <div class="load-receipt-tnk__banner">
                    <div class="text-large"><b>${this.receiptPage ?
            `Scontrino` : `Ricevuta`}</b></div>
                    <div class="mb-30">Totale prodotti Henkel: <b>€${costProduct}</b></div>
                      
                    <div class="icon">
                        <div class="chips-points">
                            <span class="chips-points__content">${earnedPoints} Punti Cuore</span>
                        </div>                
                    </div>
                     ${bonusHtml}
                     <div class="text-small mt-30 red-link">I punti ti verranno accreditati entro pochi giorni previa verifica dello scontrino. 
                        Li troverai nella tua <a href="/reserved/lista-attivita" >lista attività</a></div>
                  
                </div>
                
               
        
                <div class="primary-button mt-30 mb-30"><a href="/reserved/carica-scontrino">Carica un altro documento d’acquisto</a>
                </div>
                <div class="secondary-button bordered"><a href="/reserved/dlovers">Vai a DLovers</a>
                </div>
        
            </div>`
        this.element.querySelector('.load-receipt-invoice').innerHTML = html;
    }


    init() {
        this.element.classList.add('loading');
        this.toggleLabelVisibility();
        this.addThankYouPageListener();
        this.checkMonthLimit();
        this.addStepperProgress();
    }
}

export default ReceiptComponent;